import {useState, useEffect, useRef} from 'react';
import client, { Socket } from 'socket.io-client';

export type Message = {
  name: string;
  text: string;
}

export type useChatValue = {
  messages: Message[];
  sendMessage: (name: string, text: string) => void;
};

export const useChat = (): useChatValue => {
  const [messages, setMessages] = useState<Message[]>([]);

  const socketRef = useRef<Socket>();

  useEffect(() => {
    if (!socketRef) {
      return;
    }
    console.log('Connectinng..');
    socketRef.current = client(process.env.REACT_APP_SOCKET_ENDPOINT || '', {
       withCredentials: false, 
       extraHeaders: {
        "meetman-header": "abcd"
      }
    });
    socketRef.current.on('broadcast', data => {
      console.log('Recieved: ' + data );
      setMessages(prevMessages => [...prevMessages, data]);
    });
    return () => {
      console.log('Disconnecting..');
      socketRef?.current?.disconnect();
    };
  }, []);

  const sendMessage = (name: string, text: string) => {
    const sendValue: Message = {
      name, text,
    };
    socketRef?.current?.emit('send', sendValue);
    setMessages(messages.concat([sendValue]));
  }

  return {messages, sendMessage};
}
  
